import { render, staticRenderFns } from "./WidgetNotes.vue?vue&type=template&id=a4717ea6&scoped=true&"
import script from "./WidgetNotes.vue?vue&type=script&lang=js&"
export * from "./WidgetNotes.vue?vue&type=script&lang=js&"
import style0 from "./WidgetNotes.vue?vue&type=style&index=0&id=a4717ea6&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4717ea6",
  null
  
)

export default component.exports